import { useTranslation } from 'libs/i18n'
import { useUserRoles } from 'shared/hooks'

export const useActionFilters = (isDisabled: boolean) => {
	const { t } = useTranslation()
	const { isStaff } = useUserRoles()

	return [
		{
			id: 'actions',
			label: t('Actions'),
			placeholder: t('Default'),
			options: [
				...(isStaff
					? [
							// customers cannot send welcome emails
							{
								value: 'emailWelcome',
								label: t('Send welcome email'),
								isDisabled
							},
							// customers cannot send end reminder emails
							{
								value: 'emailReminder',
								label: t('Send email reminder'),
								isDisabled
							},
							{
								value: 'emailConfirm',
								label: t('Send product confirm email'),
								isDisabled
							}
						]
					: []),
				{
					value: 'confirm',
					label: t('Confirm products'),
					isDisabled
				},
				...(isStaff
					? [
							{
								value: 'unconfirm',
								label: t('Unconfirm products'),
								isDisabled
							}
						]
					: []),
				{
					value: 'export',
					label: t('Export')
				},
				...(isStaff
					? [
							// customers cannot delete bookings
							{
								value: 'delete',
								label: t('Delete'),
								isDisabled
							}
						]
					: [])
			]
		}
	]
}

export const useSortingFilters = () => {
	const { t } = useTranslation()
	const { isStaff } = useUserRoles()

	return {
		id: 'ordering',
		label: t('Sort by'),
		placeholder: t('Default'),
		options: [
			// {
			// 	value: 'store',
			// 	label: `${t('Sort by')} store asc`
			// },
			// {
			// 	value: '-store',
			// 	label: `${t('Sort by')} store desc`
			// },
			{
				value: 'start_date',
				label: `${t('Sort by')} start_date asc`
			},
			{
				value: '-start_date',
				label: `${t('Sort by')} start_date desc`
			},
			{
				value: '_end_date',
				label: `${t('Sort by')} end_date asc`
			},
			{
				value: '-_end_date',
				label: `${t('Sort by')} end_date desc`
			},
			...(isStaff
				? [
						// customers only see active bookings
						{
							value: 'is_active',
							label: `${t('Sort by')} is_active asc`
						},
						{
							value: '-is_active',
							label: `${t('Sort by')} is_active desc`
						},

						// customers only see their own bookings
						{
							value: 'user__name',
							label: `${t('Sort by')} user asc`
						},
						{
							value: '-user__name',
							label: `${t('Sort by')} user desc`
						}
					]
				: [])
		]
	}
}

export const useFilters = () => {
	const { t } = useTranslation()
	const { isStaff } = useUserRoles()

	return [
		// customers only receive active bookings
		...(isStaff
			? [
					{
						id: 'is_active',
						label: t('Status'),
						placeholder: t('All'),
						options: [
							{
								value: 'true',
								label: t('Active')
							},
							{
								value: 'false',
								label: t('Expired')
							}
						]
					}
				]
			: []),
		{
			id: 'status',
			label: t('Booking status'),
			placeholder: t('All'),
			options: [
				{
					value: 'RESERVED',
					label: t('Reserved')
				},
				{
					value: 'CONFIRMED',
					label: t('Confirmed')
				},
				{
					value: 'ARRIVED',
					label: t('Arrived')
				},
				{
					value: 'NO_SHOW',
					label: t('No show')
				},
				{
					value: 'OVERDUE',
					label: t('Overdue')
				},
				{
					value: 'COMPLETED',
					label: t('Completed')
				},
				{
					value: 'CANCELLED',
					label: t('Cancelled')
				},
				{
					value: 'ABANDONED',
					label: t('Abandoned')
				}
			]
		}
	]
}
